import { theme } from '@superhi/design'
import styled from 'styled-components'

export const Chapters = styled.div`
  > *:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.GREY_50};
    padding-bottom: 24px;
    margin-bottom: 24px;

    @media ${theme.breakpoints.medium} {
      padding-bottom: 40px;
      margin-bottom: 40px;
    }
  }
`
